package com.wintermar.inspection.core.ui.component.modal.util

data class ModalActionModel(
    val showAction: Boolean,
    val label: String,
    val secondLabel: String? = null,
    val onClick: () -> Unit,
    val secondOnClick: (() -> Unit) = {},
    val isDangerAction: Boolean = false,
    val withBackgroundHeader: Boolean = false,
    val isSameWeight: Boolean = false,
    val widthButtonBasedOnText: Boolean = false,
    val disableOnClicked: Boolean = false,
    val disableSecondOnClicked: Boolean = false
)
